import { SwiperSlide } from "swiper/react"
import { Card } from "@components/anti/Card"
import { Image, RatioImage } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import {
  linkProductsServices,
  linkProductsServicesConcession,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { imgUrl } from "src/mixins"

function LocationDetailConcession({ concessions, locale }) {
  const [trigger, anim, inView] = useScrollAnim()
  return (
    <section className="sc-location-detail-concession" ref={trigger}>
      <div className="wrapper-ellipse">
        <RatioImage
          ratio="r-3-4"
          src="/img/misc/img_misc-location-concession-ellipse.png"
          alt="logo"
        />
      </div>
      <div className={`img-bg ${inView ? "in-view" : ""}`}>
        <Image
          src="/img/bg/img_bg-xxi-transparent.png"
          alt="bg"
          className="img-fluid"
          fill
        />
      </div>
      <div className="py-main">
        <div className="container">
          <h1 className={`title ${anim(1)}`}>
            {translations[`loc_detail_concession_title_${locale}`]}
          </h1>
          <p className={`text ${anim(2, "fadeInUp8")}`}>
            {translations[`loc_detail_concession_text_${locale}`]}
          </p>
          <Link
            className={`link ${anim(3)}`}
            withArrow
            href={`${linkProductsServices}`}
          >
            {translations[`loc_detail_concession_text_btn_${locale}`]}
          </Link>
          <SliderSwiper
            loop={false}
            breakpoints={{
              640: {
                slidesPerView: 1.6,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 15,
              },
            }}
            className="location-detail-concession-slider mt-4"
          >
            {concessions?.map((item, i) => (
              <SwiperSlide key={`location-detail-concession-slider__item-${i}`}>
                <Card
                  className={`location-detail-concession-slider__item ${anim(
                    i + 4
                  )}`}
                  img={imgUrl(item.thumb_image)}
                  variant="overlay"
                  imgRatio="r-3-4"
                  title={item[`title_${locale}`]}
                  titleClassName="h-50px"
                  text=""
                  link={`${linkProductsServicesConcession}/${item.slug}`}
                >
                  <p>{item.title}</p>
                  <div className="button">
                    <i className="air ai-arrow-right" />
                  </div>
                </Card>
              </SwiperSlide>
            ))}
          </SliderSwiper>
        </div>
      </div>
    </section>
  )
}

export default LocationDetailConcession
